import { type PropsWithChildren, type ReactNode } from "react";
import {
  SidebarContent,
  SidebarHeader,
  Sidebar as UISidebar,
  useSidebar,
} from "ui";

import { AccountMenu } from "src/components/AccountMenu";
import { SidebarCommunicationActions } from "src/components/SidebarCommunicationActions";

interface BaseSidebarProps extends PropsWithChildren {
  header?: ReactNode;
  tabs?: ReactNode;
  showAccountMenu?: boolean;
  showCommunicationActions?: boolean;
}
export function BaseSidebar(props: BaseSidebarProps) {
  const sidebar = useSidebar();

  return (
    <UISidebar collapsible="icon">
      <SidebarHeader>
        {props.showAccountMenu === false ? null : <AccountMenu sidebar />}
        {props.header}
        {props.tabs && sidebar.state === "expanded" ? props.tabs : null}
      </SidebarHeader>
      <SidebarContent>
        {props.showCommunicationActions === false ? null : (
          <SidebarCommunicationActions />
        )}
        {props.children}
      </SidebarContent>
    </UISidebar>
  );
}
